document.addEventListener('DOMContentLoaded', () => {
  const wrapper = document.querySelector('.logolist--inner');
  let scrollAmount = 0;
  const speed = 1; // Adjust speed (higher = faster)

  function autoScroll() {
    if (wrapper) {
      scrollAmount += speed;
      if (scrollAmount >= wrapper.scrollWidth - wrapper.clientWidth) {
        scrollAmount = 0; // Reset scroll to beginning
      }
      wrapper.scrollTo({ left: scrollAmount, behavior: 'smooth' });
    }
  }

  setInterval(autoScroll, 30); // Adjust interval for smoothness
});
